import { IncidentCard, Stack } from '@all-manager/design-system-v2';
import type { IncidentDatabase } from "../../../../../types";

type Props = {
  incidents: IncidentDatabase[];
  onNavigateToIncidents?: () => void;
};

export default function OngoingIncidentSection(props: Props) {
  if (props.incidents.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2}>
      {props.incidents.map((incident) => (
        <IncidentCard
          key={incident.id}
          incident={incident}
          onNavigate={props.onNavigateToIncidents ? () => props.onNavigateToIncidents?.() : undefined}
        />
      ))}
    </Stack>
  );
}
